  import React, { useEffect, useState } from "react";
  import axios from 'axios';
  import {
    Row,
    Col,
    Card,
    Form,
  } from 'react-bootstrap';
  import { Icon } from '@iconify/react';
  import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
  } from "recharts";
  
import { getDashboard,getUserStats,getRevenueStats } from "../../api/dashboardService";
  const gradientColors = ["#3895F3 ", "#fff"];
  const formatYAxisTick = (value) => value;
  const formatYAxisTick2 = (value) => `$ ${value}`;
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{` ${payload[0].value} Users`}</p>
        </div>
      );
    }

    return null;
  };
  const CustomTooltip2 = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`$ ${payload[0].value} `}</p>
        </div>
      );
    }

    return null;
  };
  export default function Dashboard() {

    const [totalUsers, setTotalUsers] = useState(0);
    const [totalTales, setTotalTales] = useState(0);
    const [totalBooks,setTotalBooks]= useState(0);
    const [aiGeneratedTales, setAiGeneratedTales] = useState(0);
    const [aiAssistedTales,setaiAssistedTales] = useState(0);
    const [userStatsByYear, setUserStatsByYear] = useState([]);
    const [revenueData, setRevenueData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [totalSubscribers, setTotalSubscribers] = useState(0);
    const [totalRevenue, setTotalRevenue] = useState(0);
    const [userStats, setUserStats] = useState([]);
    const [period, setPeriod] = useState('monthly');
    const [period1, setPeriod1] = useState('monthly');

    const [revenueStats, setRevenueStats] = useState([]);
  

    const fetchData = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          throw new Error('No token found');
        }
        const response = await getDashboard();
        const { data } = response;

        setTotalUsers(data.totalUsers);
        setTotalTales(data.totalTales);
        setTotalBooks(data.totalBooks);
        setTotalSubscribers(data.totalSubscribers);
        setAiGeneratedTales(data.aiGeneratedStorie);
        setTotalRevenue(data.totalRevenue);
        setUserStatsByYear(data.userStatsByYear);
        setRevenueData(data.userStatsByWeek);
        setUserData(data.userStatsByYear);
        setaiAssistedTales(data.aiAssistedTales);

      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.error('Token is invalid or expired, please log in again');
        } else {
          console.error('Error fetching dashboard data', error);
        }
      }
    };

    const fetchUserStats = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          throw new Error('No token found');
        }
        const response = await getUserStats(period);
        const { data } = response;
        setUserStats(data);
      } catch (error) {
        console.error('Error fetching user stats', error);
      }
    };

    const fetchRevenueStats = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No token found");
        }
  
        const response = await getRevenueStats(period1);
        const { data } = response;
        setRevenueStats(data);
        const revenueData = data; 
        const chartData = revenueData.map(stat => ({
          name: stat.period, 
          Value: stat.revenue, 
        }));
  
        setRevenueStats(chartData);
      } catch (error) {
        console.error("Error fetching revenue stats", error);
      }
    };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchUserStats();
  }, [period]); 


  useEffect(() => {
    fetchRevenueStats();
  }, [period1]);
  

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value); 
  };
  const handlePeriodChange1 = (e) => {
    setPeriod1(e.target.value); 
  };

    return (
      <React.Fragment>
        <Row className="g-3">
          <Col lg={3}>
            <div className="stats">
              <span className="statsicon"><Icon icon="tabler:users" /></span>
              <div className="stats-cont">
                <h4>Total Users</h4>
                <p>{totalUsers}</p>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className="stats">
              <span className="statsicon statsblue"><Icon icon="ph:scroll"/></span>
              <div className="stats-cont">
                <h4>Total Tales</h4>
                <p>{totalTales} </p>
              </div>
            </div>
          </Col> 
          <Col lg={3}>
            <div className="stats">
              <span className="statsicon statsblue"><Icon icon="ph:books"/></span>
              <div className="stats-cont">
                <h4>Total Books</h4>
                <p>{totalBooks} </p>
              </div>
            </div>
          </Col> 
           <Col lg={3}>
            <div className="stats">
              <span className="statsicon statsblue"><Icon icon="ph:users-three"/></span>
              <div className="stats-cont">
                <h4>Subscribers</h4>
                <p>5 </p>
              </div>
            </div>
          </Col> 
        </Row>
        <Row className="mt-2">
        <Col lg={12}>
          <Card className="mt-4">
            <Card.Header className="d-flex align-items-center justify-content-between">
              <h5>Total Users</h5>
              <Form.Select className="maxwidth120" value={period} onChange={handlePeriodChange}>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </Form.Select>
            </Card.Header>
            <Card.Body>
              <ResponsiveContainer width="100%" height={300}>
                <AreaChart data={userStats} margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
                  <CartesianGrid stroke="#EAEAEA" strokeWidth={1} />
                  <XAxis dataKey={period === 'weekly' ? 'week' : period === 'monthly' ? 'month' : 'year'} />
                  <YAxis />
                  <Tooltip />
                  <Area type="monotone" dataKey="count" stroke="#3895F3" fill="#3895F3" />
                </AreaChart>
              </ResponsiveContainer>
            </Card.Body>
          </Card>
        </Col>
        </Row>
      </React.Fragment>
    );
  }
